import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class HttpService {

	constructor() {}

	getPromise<T>(request: Observable<T>): Promise<T | any> {
		return new Promise<T>(resolve => {
			request.subscribe({
				next: (res: T) => resolve(res),
				error: (err: T) => resolve(err)
			});
		});
	}
}
